export default __webpack_public_path__ + "static/media/checked_dark.d1affe87.png";